<!-- <div class="home-btn d-none d-sm-block">
    <a routerLink="" ><i class="mdi mdi-home-variant h2 text-dark"></i></a>
</div> -->
<div>
  <div class="container-fluid p-0">
    <div class="row no-gutters">
      <div class="col-lg-7 bg-light">
        <div
          class="authentication-page-content d-flex align-items-center min-vh-100"
        >
          <div class="w-100">
            <div class="row justify-content-center">
              <div class="col-lg-8 justify-content-center">
                <div>
                  <div class="text-center">
                    <div>
                      <a routerLink="/" class="logo"
                        ><img
                          src="assets/images/logo_qrpaybox-bup.png"
                          width="220"
                          alt="logo"
                      /></a>
                    </div>
                    <h4 class="font-size-16 font-bold">Xin chào!</h4>
                    <p class="text-muted">
                      {{'Chọn cửa hàng để tiếp tục sử dụng'}}
                    </p>
                  </div>

                  <div class="p-4 mt-1 rounded border-custom">
                    <div>
                      <div class="text-center mb-3">
                        <button
                          class="btn btn-info"
                          (click)="openModal(content)"
                        >
                          {{'Thêm mới cửa hàng' | translate}}
                        </button>
                      </div>
                      <h6 class="ml-2">
                        Tìm kiếm cửa hàng
                      </h6>
                      <div class="d-flex justify-content-between row px-2">
                        <div class="position-relative col-md-8">
                          <input
                            style="height: 2rem;"
                            [(ngModel)]="filter.name"
                            class="form-control rounded p-4 col"
                            type="text"
                            placeholder="Nhập thông tin"
                          />
                          <span
                            class="clearFilter"
                            *ngIf="searching"
                            (click)="clearFilter()"
                            >x</span
                          >
                        </div>
                        <button
                          type="button"
                          (click)="submitFilter()"
                          class="text-white btn-info rounded col-md-4"
                        >
                          Tìm kiếm
                        </button>
                      </div>
                    </div>
                    <hr class="my-4" />
                    <div
                      class="overflow-auto custom-scrollbar"
                      style="max-height: 200px; min-height: 200px;"
                    >
                      <div
                        *ngFor="let index of listData;"
                        (click)="showId(index)"
                        class="custom-item d-flex"
                      >
                        <img
                          src="assets/images/store.png"
                          class="m-1"
                          alt="avatar"
                          width="60"
                        />
                        <div class="p-2">
                          <div>{{index.name}} - {{index.code}}</div>
                          <div>{{index.leader}}</div>
                        </div>
                        <!-- <div>Điểm thu</div> -->
                      </div>
                    </div>
                    <hr />
                    <div class="mt-4 text-center">
                      <a
                        class="dropdown-item text-danger"
                        href="javascript: void(0);"
                        (click)="logout()"
                        ><i
                          class="ri-shut-down-line align-middle mr-1 text-danger"
                        ></i>
                        {{ 'Đăng xuất' | translate}}</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-5 d-none d-lg-block">
        <div style="width: 100%; height: 100%;">
          <!-- <div> -->
          <img
            class="img-fluid"
            src="assets/images/bg-workspace.jpg"
            style="height: 100% !important;"
            alt="bg-logo"
          />
          <!-- </div>   -->
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #content role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">
      {{(formData.value.id ? "Chỉnh sửa" : "Thêm mới") | translate}}
    </h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form (ngSubmit)="saveData()" [formGroup]="formData">
        <div class="row">
          <div class="form-group row col-md-12">
            <label class="col-md-3 col-form-label required_label"
              >{{'Tên cửa hàng' | translate}}</label
            >
            <div class="col-md-9">
              <input
                type="text"
                class="form-control"
                formControlName="name"
                [ngClass]="{'is-invalid': submitted && form.name.errors}"
              />
            </div>
          </div>
          <div class="form-group row col-md-12">
            <label class="col-md-3 col-form-label required_label"
              >{{'Địa chỉ' | translate}}</label
            >
            <div class="col-md-9">
              <input
                type="text"
                class="form-control"
                formControlName="terminalAddress"
                [ngClass]="{'is-invalid': submitted && form.terminalAddress.errors}"
              />
            </div>
          </div>
          <div class="form-group row col-md-12">
            <label class="col-md-3 col-form-label required_label"
              >{{'Ngân hàng' | translate}}</label
            >
            <div class="col-md-9">
              <select
                [(ngModel)]="binNumber"
                class="form-select"
                aria-label="Default select example"
                class="form-control"
                formControlName="bank_name"
                [ngClass]="{'is-invalid': submitted && form.bank_name.errors}"
              >
                <option value="{{item.id}}" *ngFor="let item of listBankname"
                  >{{item.name}}</option
                >
              </select>
              <!-- <input type="text" class="form-control" formControlName="bank_name"
                                [ngClass]="{'is-invalid': submitted && form.bank_name.errors}" value="MB Bank" readonly /> -->
            </div>
          </div>
          <div class="form-group row col-md-12">
            <label class="col-md-3 col-form-label required_label"
              >{{'Số tài khoản' | translate}}</label
            >
            <div class="col-md-9">
              <input
                type="text"
                class="form-control"
                formControlName="terminalBankAcc"
                [(ngModel)]="accountNumber"
                [ngClass]="{'is-invalid': submitted && form.terminalBankAcc.errors}"
                (blur)="onInputBlur()"
              />
            </div>
          </div>
          <div class="form-group row col-md-12" *ngIf="searching">
            <label class="col-md-3 col-form-label required_label"
              >{{'Chủ tài khoản' | translate}}</label
            >
            <div class="col-md-9">
              <input
                type="text"
                [ngModel]="bank_accountName"
                class="form-control"
                formControlName="bank_account_name"
                [ngClass]="{'is-invalid': submitted && form.bank_account_name.errors}"
                readonly
              />
            </div>
          </div>
        </div>

        <div class="text-center" *ngIf="searching">
          <!-- <button type="button" class="btn btn-secondary btn-sm mr-3"
                        (click)="modal('close click')">{{'Đóng' | translate}}</button>
                    <button type="submit" class="btn btn-primary btn-sm">{{'Lưu' | translate}}</button> -->
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px;"
            (click)="modal('close click')"
          >
            {{'Đóng' | translate}}
          </button>
          <button
            type="submit"
            class="btn btn-success btn-lg"
            style="width: 150px;"
          >
            {{'Lưu' | translate}}
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>
<!-- end page -->
